import DateRangePicker from "@amzn/meridian/date-range-picker";
import React from "react";
import { useFilterSheets } from "./hooks";
import { useAppDispatch } from "../../app/store/hooks";
import { IFilterDateRangeProps } from "./definitions";

export const FilterDateRange: React.FC<IFilterDateRangeProps> = ({ dateRangeInfo }) => {
    const dispatch = useAppDispatch();
    const { filterMap, handleFilterMapUpdate } = useFilterSheets();

    return (
        <DateRangePicker
            value={filterMap.get(dateRangeInfo.keyValue)?.value || ["", ""]}
            onChange={selectedValue =>
                dispatch(
                    handleFilterMapUpdate({
                        type: "UPDATE",
                        filterKey: dateRangeInfo.keyValue,
                        value: selectedValue,
                    })
                )
            }
            startLabel={dateRangeInfo.startLabel}
            endLabel={dateRangeInfo.endLabel}
            endPlaceholder={dateRangeInfo.startPlaceHolder}
            startPlaceholder={dateRangeInfo.endPlaceHolder}
            monthsInView={1}
            legend={dateRangeInfo.label}
        />
    );
};
